import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import InstagramIcon from 'mdi-react/InstagramIcon'
import FacebookIcon from 'mdi-react/FacebookIcon'

import FlickrIcon from 'icons/FlickrIcon'

import { linksStyle } from './SocialLinks.styles'

const SOCIAL_LINKS = {
  flickr: {
    path: 'https://www.flickr.com/photos/zuyetawarmatik',
    title: 'Zuyet Awarmatik\'s Flickr',
    icon: FlickrIcon,
    sizeProps: 'fontSize'
  },
  instagram: {
    path: 'https://www.instagram.com/zuyetawarmatrip',
    title: 'Zuyet Awarmatrip\'s Instagram',
    icon: InstagramIcon,
    sizeProps: 'size'
  },
  facebook: {
    path: 'https://www.facebook.com/zuyetawarmatrip',
    title: 'Zuyet Awarmatrip\'s Facebook',
    icon: FacebookIcon,
    sizeProps: 'size'
  },
}

function SocialLinks({ size, shownKeys }) {
  return (
    <Box sx={linksStyle}>
      {shownKeys.map((key) => {
        const { path, title, icon: Icon, sizeProps } = SOCIAL_LINKS[key]
        return (
          <a key={key} href={path} title={title} target="_blank" rel="noopener noreferrer">
            <Icon color="currentcolor" {...{ [sizeProps]: size }} />
          </a>
        )
      })}
    </Box>
  )
}

const { any, arrayOf, string } = PropTypes

SocialLinks.propTypes = {
  size: any,
  shownKeys: arrayOf(string)
}

SocialLinks.defaultProps = {
  size: '1.5em',
  shownKeys: Object.keys(SOCIAL_LINKS)
}

export default SocialLinks
